module.exports = __webpack_public_path__ + "static/media/github.0dd05934.png";